export default __webpack_public_path__ + "static/media/Courtyard.d7f969e6.jpg";